"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoDescription = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styles_1 = require("./styles");
function InfoDescription(_a) {
    var children = _a.children, leftComponent = _a.leftComponent, rightComponent = _a.rightComponent, tag = _a.tag, title = _a.title, colorTag = _a.colorTag, _b = _a.maxWidthDescription, maxWidthDescription = _b === void 0 ? 600 : _b, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, _d = _a.flexDirection, flexDirection = _d === void 0 ? 'row' : _d, iconTag = _a.iconTag, cssDescription = _a.cssDescription;
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, __assign({ flexDirection: flexDirection }, { children: [leftComponent && leftComponent, (0, jsx_runtime_1.jsxs)(styles_1.Description, __assign({ colorTag: colorTag, maxWidthDescription: maxWidthDescription, fullWidth: fullWidth, style: __assign({ flexShrink: 0 }, cssDescription) }, { children: [(0, jsx_runtime_1.jsxs)("span", { children: [iconTag && iconTag, tag] }), (0, jsx_runtime_1.jsx)("h1", { children: title }), children] })), rightComponent && rightComponent] })));
}
exports.InfoDescription = InfoDescription;
